import React from 'react'

export const DeleteSampling = () => {
    return (
        <div>

        </div>
    )
}
